import React from 'react';
import { Modal } from 'antd';
import { CheckCircle, Smartphone, Users, Settings } from 'lucide-react';
import '../styles/designSystem.css';
import './TrialWelcomeModal.css';

interface TrialWelcomeModalProps {
  visible: boolean;
  onClose: () => void;
}

const TrialWelcomeModal: React.FC<TrialWelcomeModalProps> = ({ visible, onClose }) => {
  const androidLink = 'https://play.google.com/store/apps/details?id=com.threesigma';
  const iosLink = 'https://apps.apple.com/be/app/3sigma-mobile-crm/id6463200219';

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      className="trial-welcome-modal"
    >
      <div className="trial-welcome-content">
        {/* Success Icon */}
        <div className="trial-welcome-icon">
          <CheckCircle size={64} strokeWidth={2} />
        </div>

        {/* Header */}
        <div className="trial-welcome-header">
          <h2 className="ds-h2">Welcome to 3Sigma CRM! 🎉</h2>
          <p className="ds-body-lg ds-text-secondary">
            Your 7-day free trial has been activated
          </p>
        </div>

        {/* Trial Info Card */}
        <div className="trial-info-card">
          <div className="trial-info-badge">
            <span className="ds-badge ds-badge-success">7 Days Free Trial</span>
          </div>
          <p className="ds-body ds-text-tertiary" style={{ marginTop: '12px' }}>
            Explore all premium features and experience the full power of 3Sigma CRM
          </p>
        </div>

        {/* Mobile App Section */}
        <div className="mobile-app-section">
          <div className="mobile-app-header">
            <Smartphone size={24} color="#0056fe" />
            <h3 className="ds-h4">Download Our Mobile App</h3>
          </div>

          <div className="mobile-app-info">
            <div className="info-item">
              <Users size={20} color="#10b981" />
              <span className="ds-body-sm">Add & manage team members</span>
            </div>
            <div className="info-item">
              <Settings size={20} color="#f59e0b" />
              <span className="ds-body-sm">Complete customization options</span>
            </div>
          </div>

          <div className="app-store-buttons">
            <a
              href={androidLink}
              target="_blank"
              rel="noopener noreferrer"
              className="app-store-button android"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
              />
            </a>
            <a
              href={iosLink}
              target="_blank"
              rel="noopener noreferrer"
              className="app-store-button ios"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="Download on the App Store"
              />
            </a>
          </div>

          <p className="ds-body-sm ds-text-tertiary" style={{ marginTop: '16px', textAlign: 'center' }}>
            <strong>Important:</strong> Team member management and full customization features are only available on the mobile app.
          </p>
        </div>

        {/* Action Button */}
        <button
          className="ds-btn ds-btn-primary ds-btn-lg"
          onClick={onClose}
          style={{ width: '100%', marginTop: '24px' }}
        >
          Get Started
        </button>
      </div>
    </Modal>
  );
};

export default TrialWelcomeModal;
